import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70c9d1c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70c9d1c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9d1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c9d1c0')) {
      api.createRecord('70c9d1c0', component.options)
    } else {
      api.reload('70c9d1c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70c9d1c0&scoped=true", function () {
      api.rerender('70c9d1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/prize/index.vue"
export default component.exports